import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '@core/auth.service';
import { CommonService } from '@modules/shared/services/common.service';

@Injectable({
  providedIn: 'root'
})
export class WhitelabelV2Guard implements CanActivate {
  userProfile;
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly cs: CommonService
  ) {
    const config = this.cs.getWhiteLabelConfiguration();
    this.userProfile = config?.user;
  }

  canActivate(): boolean {
    if (this.authService.isWhiteLabelWebsite()) {
      this.router.navigate(['']);
      return false;
    } else {
      return true;
    }
  }
}
